import { Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { ActionItemProps } from './actionRegistry';
import { StatusIndicator } from './StatusIndicator';
import { getItemStyles } from './itemStyles';

/**
 * Move To Stage action component
 * Shows stage move progress
 */
export const MoveToStage = ({ item }: ActionItemProps) => {
  const styles = getItemStyles(item.status);
  const isFailed = item.status === 'failed';

  return (
    <Flex
      py="12px"
      px="20px"
      alignItems={isFailed ? 'flex-start' : 'center'}
      justifyContent="space-between"
      flexDir={isFailed ? 'column' : 'row'}
      borderBottom="1px solid"
      borderColor={styles.borderColor}
      bg={styles.container.bg}
      _first={{ borderTop: '1px solid', borderColor: styles.borderColor }}
      _last={{
        borderBottom: isFailed ? '1px solid' : 'none',
        borderColor: styles.borderColor,
      }}
    >
      <Flex alignItems="center" gap="10px" flex={1} minW={0}>
        <KText
          size="sm"
          noOfLines={1}
          flex={1}
          enableTooltip
          tooltipText={item.name}
          color={styles.text.color}
        >
          {item.name}
        </KText>
      </Flex>

      <Flex alignItems="center" flexShrink={0}>
        <StatusIndicator
          status={item.status}
          progress={item.progress}
          errorType={item.errorType}
        />
      </Flex>
    </Flex>
  );
};
